import { createContext, useContext } from 'react';
import { SimulatedLoan } from './vehicleTourScript';

// §2/§4: everything the real screens need to know to render the simulated
// loan instead of their own fetched data while the tour is active, and
// nothing more — in particular, no way for a descendant to reach into the
// driver or flip `active` itself. Only vehicle-tour.provider.tsx produces
// this value.
export interface VehicleTourContextValue {
  active: boolean;
  simulatedLoan: SimulatedLoan | null;
  simulatedHistory: SimulatedLoan[];
  startTour: (currentTab: 'actual' | 'historial') => void;
}

const defaultValue: VehicleTourContextValue = {
  active: false,
  simulatedLoan: null,
  simulatedHistory: [],
  startTour: () => {},
};

export const VehicleTourContext = createContext<VehicleTourContextValue>(defaultValue);

export const useVehicleTour = (): VehicleTourContextValue => useContext(VehicleTourContext);
